import * as LJS from "../../../lib/littlejs.esm";
import { tilesize } from '../../const/tiles.ts';
import Actionable from "./actionable.ts";
const disabledTileIndex = 3;
const enabledTileIndex = 4;
/*
 * Door block the way if closed, and allow you to pass through if opened
 */
class Lever extends Actionable {
    constructor(pos, linkedActionable) {
        super(pos, disabledTileIndex);
        // Overridden by the child class to make the actionable interactive
        this.key = "KeyE";
        this.state = "disabled";
        this.setCollision(false, false, false, false);
        this.mass = 0; // Not affected by gravity
        this.linkedActionable = linkedActionable;
    }
    action() {
        console.log("Action triggered on Lever");
        this.linkedActionable.action();
        if (this.state == "disabled") {
            this.state = "enabled";
            this.tileInfo = LJS.tile(enabledTileIndex, tilesize);
        }
        else {
            this.state = "disabled";
            this.tileInfo = LJS.tile(disabledTileIndex, tilesize);
        }
    }
}
export default Lever;
